import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Star, UserRound } from 'lucide-react';
import { shortTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  const hasSamples = shortTestimonials.some(testimonial => testimonial.isSample);
  return <section className="py-12 bg-slate-50 border-y border-slate-200" data-id="element-281" data-mp="3nzv73wfw6dig">
      <div className="max-w-7xl mx-auto px-4" data-id="element-282" data-mp="3nxiij0fmp4wf">
        <div className="text-center mb-7" data-id="element-283" data-mp="5kt0x0xqa9ku">
          <h2 className="text-blue-950 font-bold tracking-widest uppercase text-sm" data-id="element-284" data-mp="5nozmrheh2ac">
            What Dog Grooming Instructors Are Saying
          </h2>
          {hasSamples && <p className="text-xs text-slate-500 mt-2" data-id="element-285" data-mp="fj9wycbixedr">
              Placeholder comments shown for layout — to be replaced with verified customer feedback.
            </p>}
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-286" data-mp="2hbolvvchjj3o">
          {shortTestimonials.map((testimonial, index) => <motion.article key={testimonial.text} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-slate-200 p-6 rounded-2xl shadow-sm shadow-blue-950/5 flex flex-col" data-id="element-287" data-mp="2cdwmyhdfawpz" data-mpi={index}>
              <div className="flex items-center justify-between gap-3 mb-4" data-id="element-288" data-mp="v378hpme1kvh">
                <div className="flex gap-1 text-orange-500" aria-label="5 out of 5 stars" data-id="element-289" data-mp="v5b9nzswk5s2">
                  {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" data-id="element-290" data-mp="143na0tjkmhxp" data-mpi={starIndex} />)}
                </div>
                {testimonial.isSample && <span className="text-xs font-bold uppercase tracking-wider text-blue-600 bg-blue-50 px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-291" data-mp="190lzuzw7c2q3">
                    Placeholder
                  </span>}
              </div>
              <p className="text-slate-800 italic mb-6 text-sm leading-relaxed" data-id="element-292" data-mp="hz30zn63m6bp">
                “{testimonial.text}”
              </p>
              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-slate-200" data-id="element-293" data-mp="d2m9cizox9tv">
                <div className="w-10 h-10 rounded-full bg-blue-950 flex items-center justify-center text-orange-500 shrink-0" aria-hidden="true" data-id="element-294" data-mp="r1udlqapn84x">
                  <UserRound size={18} data-id="element-295" data-mp="10ww2qm4zka7i" />
                </div>
                <div className="min-w-0" data-id="element-296" data-mp="w0fcnme87lrs">
                  <div className="font-bold text-blue-950 text-sm" data-id="element-297" data-mp="vzdt0tj59qyg">{testimonial.role}</div>
                  <div className="flex items-center gap-1 text-xs text-slate-500" data-id="element-298" data-mp="19q93ga9akg45">
                    <MapPin size={11} className="text-blue-600 shrink-0" data-id="element-299" data-mp="15qqhrc9nc109" />
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}